export const checkAuthentication = (token: any, navigate: any) =>
  !token && navigate('/auth');
